export default "__VITE_ASSET__197940d9__"